(() => {
  const normalize = (str) =>
    String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  function parseCountLabel(label) {
    const n = normalize(label);
    if (!n) return null;
    if (n.includes('sem personal') || n === 'sem' || n.startsWith('sem ')) return 0;
    // "1 personalização", "2 personalizações", "1x personalizacao", etc.
    let m = n.match(/(\d+)\s*x?\s*personaliz/);
    if (m) return parseInt(m[1], 10);
    m = n.match(/personaliz\w*\s*:?\s*(\d+)/);
    if (m) return parseInt(m[1], 10);
    return null;
  }

  function countLabel(count) {
    if (count <= 0) return 'Sem personalização';
    if (count === 1) return '1 personalização';
    return `${count} personalizações`;
  }

  function countSelectedLabel(count) {
    if (count <= 0) return 'Nenhuma personalização selecionada';
    if (count === 1) return '1 personalização selecionada';
    return `${count} personalizações selecionadas`;
  }

  function findVariantValue(values, count) {
    if (!values || !values.length) return null;
    for (const v of values) {
      const c = parseCountLabel(v.label);
      if (c === count) return v;
    }
    if (count === 0) {
      return values.find((v) => normalize(v.label).includes('sem')) || null;
    }
    return null;
  }

  function resolveProductCatalog(catalog, productMeta) {
    const products = catalog.products || [];
    const handle = normalize(productMeta.handle);
    const title = normalize(productMeta.title);

    for (const entry of products) {
      const handles = (entry.handles || []).map(normalize);
      if (handle && handles.includes(handle)) return entry;
    }

    for (const entry of products) {
      const parts = (entry.titleContains || []).map(normalize).filter(Boolean);
      if (!parts.length) continue;
      if (parts.every((p) => title.includes(p))) return entry;
    }

    return null;
  }

  function selectPersonalizationValue(root, productMeta, count, notify) {
    const valueMeta = findVariantValue(productMeta.values, count);
    if (!valueMeta) return false;

    const sectionId = root.dataset.sectionId;
    const vs =
      document.getElementById('variant-selects-' + sectionId) ||
      root.closest('variant-selects') ||
      document.querySelector('variant-selects');
    if (!vs) return false;

    const inputs = Array.from(vs.querySelectorAll('input[type="radio"]'));
    let matched = null;

    for (const input of inputs) {
      if (valueMeta.id && String(input.dataset.optionValueId) === String(valueMeta.id)) {
        matched = input;
        break;
      }
      if (normalize(input.value) === normalize(valueMeta.label)) {
        matched = input;
        break;
      }
    }

    if (!matched) {
      const sels = vs.querySelectorAll('select');
      for (const sel of sels) {
        for (const opt of Array.from(sel.options)) {
          if (normalize(opt.value) === normalize(valueMeta.label)) {
            if (sel.value !== opt.value) {
              sel.value = opt.value;
              if (notify) sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return true;
          }
        }
      }
      return false;
    }

    if (matched.checked) return true;
    matched.checked = true;
    if (notify) {
      matched.dispatchEvent(new Event('input', { bubbles: true }));
      matched.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function artNeedsName(type) {
    return type === 'custom_name' || type === 'custom_name_number';
  }

  function artNeedsNumber(type) {
    return type === 'custom_name_number';
  }

  function namePlaceholderFor(art) {
    if (art.namePlaceholder) return art.namePlaceholder;
    const n = normalize(art.name + ' ' + (art.id || ''));
    if (n.includes('bolsonaro')) return 'Bolsonaro';
    if (n.includes('neymar') || n.includes('num-10') || n.includes('numeracao 10')) return 'Neymar JR';
    return 'Nome';
  }

  function numberPlaceholderFor(art) {
    return art.numberPlaceholder || 'Número';
  }

  function storageKey(handle) {
    return 'shir7-pers-state:' + (handle || 'product');
  }

  function loadPersState(handle) {
    try {
      const raw = sessionStorage.getItem(storageKey(handle));
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function savePersState(handle, data) {
    try {
      sessionStorage.setItem(storageKey(handle), JSON.stringify(data));
    } catch (e) {
      /* ignore */
    }
  }

  function clearPersState(handle) {
    try {
      sessionStorage.removeItem(storageKey(handle));
    } catch (e) {
      /* ignore */
    }
  }

  /** Lê o radio/select de personalização já marcado no DOM */
  function readCurrentPersCount(root, productMeta) {
    const sectionId = root.dataset.sectionId;
    const vs =
      document.getElementById('variant-selects-' + sectionId) ||
      root.closest('variant-selects') ||
      document.querySelector('variant-selects');
    if (!vs) return 0;

    const checked = vs.querySelector(
      '[data-shir7-pers-auto] input[type="radio"]:checked, fieldset.product-form__input--pers-auto input[type="radio"]:checked'
    );
    if (checked) {
      const c = parseCountLabel(checked.value);
      if (c !== null) return c;
    }

    // tenta qualquer radio de personalização
    for (const input of vs.querySelectorAll('input[type="radio"]:checked')) {
      const c = parseCountLabel(input.value);
      if (c !== null) return c;
    }

    // fallback productMeta labels
    for (const v of productMeta.values || []) {
      // skip
    }
    return 0;
  }

  function initRoot(root) {
    if (root.dataset.shir7Ready === '1') return;
    root.dataset.shir7Ready = '1';

    const host = root.parentElement || document;
    const catalogEl =
      host.querySelector('[data-shir7-pers-catalog]') || document.querySelector('[data-shir7-pers-catalog]');
    const productEl =
      host.querySelector('[data-shir7-pers-product]') || document.querySelector('[data-shir7-pers-product]');
    if (!catalogEl || !productEl) return;

    let catalog;
    let productMeta;
    try {
      catalog = JSON.parse(catalogEl.textContent.trim());
      productMeta = JSON.parse(productEl.textContent.trim());
    } catch (e) {
      console.error('SHIR7 personalization config error', e);
      return;
    }

    const productEntry = resolveProductCatalog(catalog, productMeta);
    if (!productEntry || !productEntry.zones || !productEntry.zones.length) {
      // Fora do catálogo: esconde UI de artes e devolve a opção normal (se existir)
      root.hidden = true;
      if (modal) modal.hidden = true;
      document.querySelectorAll('[data-shir7-pers-auto]').forEach((el) => {
        el.classList.remove('visually-hidden', 'product-form__input--pers-auto');
        el.removeAttribute('aria-hidden');
      });
      return;
    }

    const assetBase = productMeta.assetBase || '';
    const zones = productEntry.zones || [];
    const modeBtns = root.querySelectorAll('[data-shir7-pers-mode]');
    const summary = root.querySelector('[data-shir7-pers-summary]');
    const summaryList = root.querySelector('[data-shir7-pers-summary-list]');
    const countLabelEl = root.querySelector('[data-shir7-pers-count-label]');
    const propsWrap = root.querySelector('[data-shir7-pers-props]');
    const openBtn = root.querySelector('[data-shir7-pers-open]');
    const handle = productMeta.handle || '';

    let modal = root.nextElementSibling;
    while (modal && !(modal.matches && modal.matches('[data-shir7-pers-modal]'))) {
      modal = modal.nextElementSibling;
    }
    if (!modal) {
      modal = host.querySelector('[data-shir7-pers-modal]');
    }
    // reutiliza modal já movido para o body (mesmo product)
    if (!modal) {
      modal = document.querySelector(`body > [data-shir7-pers-modal][data-product-handle="${handle}"]`);
    }
    if (modal) {
      modal.dataset.productHandle = handle;
    }

    const zonesEl = modal?.querySelector('[data-shir7-pers-zones]');
    const modalCount = modal?.querySelector('[data-shir7-pers-modal-count]');
    const confirmBtn = modal?.querySelector('[data-shir7-pers-confirm]');

    const selection = {};
    let zonesBuilt = false;
    let opening = false;

    function artImageUrl(image) {
      if (!image) return '';
      if (/^https?:\/\//i.test(image)) return image;
      // Prefer WebP quando o catálogo ainda apontar PNG antigo
      const file = String(image).replace(/\.png$/i, '.webp');
      return assetBase + file;
    }

    function getCount() {
      return Object.keys(selection).filter((z) => selection[z] && selection[z].artId).length;
    }

    function persist() {
      const count = getCount();
      if (count <= 0) {
        clearPersState(handle);
        return;
      }
      const entries = {};
      Object.keys(selection).forEach((k) => {
        if (selection[k] && selection[k].artId) entries[k] = selection[k];
      });
      savePersState(handle, { count, selection: entries, mode: 'com' });
    }

    function restoreFromStorage() {
      const data = loadPersState(handle);
      if (!data || !data.selection) return 0;
      Object.keys(selection).forEach((k) => delete selection[k]);
      Object.keys(data.selection).forEach((k) => {
        selection[k] = data.selection[k];
      });
      return getCount();
    }

    function zoneStatusEl(zoneWrap) {
      return zoneWrap.querySelector('[data-zone-status]');
    }

    function updateZoneStatus(zoneWrap, zoneId) {
      const status = zoneStatusEl(zoneWrap);
      if (!status) return;
      const s = selection[zoneId];
      if (s && s.artId) {
        status.textContent = 'selecionado';
        status.hidden = false;
      } else {
        status.textContent = '';
        status.hidden = true;
      }
    }

    function renderZones() {
      if (!zonesEl) return;

      if (zonesBuilt) {
        zones.forEach((zone) => {
          const zoneWrap = zonesEl.querySelector(`[data-zone-id="${zone.id}"]`);
          if (zoneWrap) {
            paintZone(zoneWrap, zone.id);
            updateZoneStatus(zoneWrap, zone.id);
          }
        });
        return;
      }

      zonesEl.innerHTML = '';
      const frag = document.createDocumentFragment();

      zones.forEach((zone) => {
        const zoneWrap = document.createElement('div');
        zoneWrap.className = 'shir7-pers-zone';
        zoneWrap.dataset.zoneId = zone.id;

        const head = document.createElement('button');
        head.type = 'button';
        head.className = 'shir7-pers-zone__head';
        head.setAttribute('aria-expanded', 'false');

        const title = document.createElement('span');
        title.className = 'shir7-pers-zone__title';
        title.textContent = zone.label;

        const status = document.createElement('span');
        status.className = 'shir7-pers-zone__status';
        status.dataset.zoneStatus = '1';
        status.hidden = true;

        const chevron = document.createElement('span');
        chevron.className = 'shir7-pers-zone__chevron';
        chevron.setAttribute('aria-hidden', 'true');

        head.appendChild(title);
        head.appendChild(status);
        head.appendChild(chevron);

        const body = document.createElement('div');
        body.className = 'shir7-pers-zone__body';
        body.hidden = true;

        const grid = document.createElement('div');
        grid.className = 'shir7-pers-zone__grid';

        (zone.arts || []).forEach((art) => {
          const card = document.createElement('div');
          card.className = 'shir7-pers-art';
          card.dataset.artId = art.id;
          card.dataset.artType = art.type || 'ready';
          card.dataset.artName = art.name;
          card.dataset.fixedNumber = art.fixedNumber || '';

          const pickBtn = document.createElement('button');
          pickBtn.type = 'button';
          pickBtn.className = 'shir7-pers-art__pick';
          pickBtn.setAttribute('aria-pressed', 'false');

          const checkMark = document.createElement('span');
          checkMark.className = 'shir7-pers-art__tick';
          checkMark.setAttribute('aria-hidden', 'true');
          pickBtn.appendChild(checkMark);

          const media = document.createElement('div');
          media.className = 'shir7-pers-art__media';
          media.setAttribute('role', 'img');
          media.setAttribute('aria-label', art.name);
          const src = artImageUrl(art.image);
          if (src) {
            // background-image (não <img>): dificulta "Salvar imagem como"
            media.style.backgroundImage = `url("${src.replace(/"/g, '\\"')}")`;
            const shield = document.createElement('span');
            shield.className = 'shir7-pers-art__shield';
            shield.setAttribute('aria-hidden', 'true');
            media.appendChild(shield);
          } else {
            const ph = document.createElement('span');
            ph.className = 'shir7-pers-art__placeholder';
            ph.textContent = art.name;
            media.appendChild(ph);
          }
          if (art.fixedNumber) {
            const badge = document.createElement('span');
            badge.className = 'shir7-pers-art__fixed-badge';
            badge.textContent = 'Nº ' + art.fixedNumber + ' fixo';
            media.appendChild(badge);
          }

          const name = document.createElement('span');
          name.className = 'shir7-pers-art__name';
          name.textContent = art.name;

          pickBtn.appendChild(media);
          pickBtn.appendChild(name);
          card.appendChild(pickBtn);

          if (artNeedsName(art.type) || artNeedsNumber(art.type) || art.fixedNumber) {
            const fields = document.createElement('div');
            fields.className = 'shir7-pers-art__fields';
            fields.hidden = true;

            if (artNeedsName(art.type)) {
              const nameInp = document.createElement('input');
              nameInp.type = 'text';
              nameInp.className = 'shir7-pers-art__input';
              nameInp.dataset.customName = '1';
              nameInp.maxLength = 18;
              nameInp.placeholder = namePlaceholderFor(art);
              nameInp.autocomplete = 'off';
              nameInp.enterKeyHint = 'done';
              nameInp.addEventListener('input', () => {
                if (selection[zone.id] && selection[zone.id].artId === art.id) {
                  selection[zone.id].customName = nameInp.value;
                }
              });
              nameInp.addEventListener('click', (e) => e.stopPropagation());
              fields.appendChild(nameInp);
            }

            if (artNeedsNumber(art.type)) {
              const numInp = document.createElement('input');
              numInp.type = 'text';
              numInp.className = 'shir7-pers-art__input';
              numInp.dataset.customNumber = '1';
              numInp.maxLength = 2;
              numInp.inputMode = 'numeric';
              numInp.pattern = '[0-9]*';
              numInp.placeholder = numberPlaceholderFor(art);
              numInp.autocomplete = 'off';
              numInp.enterKeyHint = 'done';
              numInp.addEventListener('input', () => {
                if (selection[zone.id] && selection[zone.id].artId === art.id) {
                  selection[zone.id].customNumber = numInp.value;
                }
              });
              numInp.addEventListener('click', (e) => e.stopPropagation());
              fields.appendChild(numInp);
            } else if (art.fixedNumber) {
              const fixedWrap = document.createElement('div');
              fixedWrap.className = 'shir7-pers-art__fixed-num';
              fixedWrap.setAttribute('aria-label', 'Número fixo ' + art.fixedNumber);

              const fixedLabel = document.createElement('span');
              fixedLabel.className = 'shir7-pers-art__fixed-num-label';
              fixedLabel.textContent = 'Número';

              const fixedValue = document.createElement('span');
              fixedValue.className = 'shir7-pers-art__fixed-num-value';
              fixedValue.textContent = art.fixedNumber;

              const fixedLock = document.createElement('span');
              fixedLock.className = 'shir7-pers-art__fixed-num-lock';
              fixedLock.textContent = 'fixo';

              const fixedHint = document.createElement('p');
              fixedHint.className = 'shir7-pers-art__fixed-num-hint';
              fixedHint.textContent = 'Número fixo desta arte — não pode ser alterado';

              fixedWrap.appendChild(fixedLabel);
              fixedWrap.appendChild(fixedValue);
              fixedWrap.appendChild(fixedLock);
              fields.appendChild(fixedWrap);
              fields.appendChild(fixedHint);
            }

            card.appendChild(fields);
          }

          pickBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const current = selection[zone.id];
            const same =
              current && String(current.artId) === String(art.id);
            if (same) {
              // 2º clique na mesma arte = desmarca
              delete selection[zone.id];
            } else {
              selection[zone.id] = {
                artId: String(art.id),
                name: art.name,
                type: art.type || 'ready',
                zoneLabel: zone.label,
                fixedNumber: art.fixedNumber || '',
                customName: '',
                customNumber: art.fixedNumber || '',
              };
            }
            paintZone(zoneWrap, zone.id);
            updateZoneStatus(zoneWrap, zone.id);
            updateClearBtn();
            updateModalCount();
          });

          grid.appendChild(card);
        });

        body.appendChild(grid);

        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'shir7-pers-art__clear';
        clear.dataset.zoneClear = zone.id;
        clear.textContent = 'Remover desta parte';
        clear.hidden = true;
        clear.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          delete selection[zone.id];
          paintZone(zoneWrap, zone.id);
          updateZoneStatus(zoneWrap, zone.id);
          updateClearBtn();
          updateModalCount();
        });
        body.appendChild(clear);

        function updateClearBtn() {
          clear.hidden = !(selection[zone.id] && selection[zone.id].artId);
        }
        zoneWrap._updateClearBtn = updateClearBtn;

        head.addEventListener('click', (e) => {
          e.preventDefault();
          const open = body.hidden;
          body.hidden = !open;
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
          zoneWrap.classList.toggle('is-open', open);
        });

        zoneWrap.appendChild(head);
        zoneWrap.appendChild(body);
        frag.appendChild(zoneWrap);
      });

      zonesEl.appendChild(frag);
      zonesBuilt = true;
      zones.forEach((zone) => {
        const zoneWrap = zonesEl.querySelector(`[data-zone-id="${zone.id}"]`);
        if (zoneWrap) {
          paintZone(zoneWrap, zone.id);
          updateZoneStatus(zoneWrap, zone.id);
          if (typeof zoneWrap._updateClearBtn === 'function') zoneWrap._updateClearBtn();
        }
      });
    }

    function paintZone(zoneWrap, zoneId) {
      const selected = selection[zoneId];
      zoneWrap.querySelectorAll('.shir7-pers-art').forEach((el) => {
        const isOn = !!(selected && String(selected.artId) === String(el.dataset.artId));
        el.classList.toggle('is-selected', isOn);

        const pickBtn = el.querySelector('.shir7-pers-art__pick');
        if (pickBtn) pickBtn.setAttribute('aria-pressed', isOn ? 'true' : 'false');

        const fields = el.querySelector('.shir7-pers-art__fields');
        if (fields) {
          fields.hidden = !isOn;
        }

        if (!isOn) {
          // limpa inputs visuais ao desmarcar
          const nameInp = el.querySelector('[data-custom-name]');
          const numInp = el.querySelector('[data-custom-number]');
          if (nameInp && document.activeElement !== nameInp) nameInp.value = '';
          if (numInp && document.activeElement !== numInp) numInp.value = '';
          return;
        }

        const nameInp = el.querySelector('[data-custom-name]');
        if (nameInp && document.activeElement !== nameInp) {
          nameInp.value = selected.customName || '';
        }
        const numInp = el.querySelector('[data-custom-number]');
        if (numInp && document.activeElement !== numInp) {
          numInp.value = selected.customNumber || '';
        }
      });
      if (typeof zoneWrap._updateClearBtn === 'function') zoneWrap._updateClearBtn();
    }

    function syncCustomFieldsFromDom() {
      zones.forEach((zone) => {
        const selected = selection[zone.id];
        if (!selected) return;
        const zoneWrap = zonesEl?.querySelector(`[data-zone-id="${zone.id}"]`);
        const artEl = zoneWrap?.querySelector(`.shir7-pers-art[data-art-id="${selected.artId}"]`);
        if (!artEl) return;
        if (artNeedsName(selected.type)) {
          selected.customName = (artEl.querySelector('[data-custom-name]')?.value || '').trim();
        }
        if (artNeedsNumber(selected.type)) {
          selected.customNumber = (artEl.querySelector('[data-custom-number]')?.value || '').trim();
        } else if (selected.fixedNumber) {
          selected.customNumber = selected.fixedNumber;
        }
      });
    }

    function formatSelectionDetail(s) {
      if (s.type === 'custom_name_number') {
        const nome = String(s.customName || '').trim();
        const num = String(s.customNumber || '').trim();
        if (nome && num) return `${nome} ${num}`;
        if (nome) return nome;
        if (num) return num;
        return s.name;
      }
      if (s.type === 'custom_name') {
        const nome = String(s.customName || '').trim();
        const num = String(s.fixedNumber || s.customNumber || '').trim();
        if (nome && num) return `${nome} ${num}`;
        if (nome) return nome;
        return s.name;
      }
      return s.name;
    }

    function updateModalCount() {
      if (modalCount) modalCount.textContent = countSelectedLabel(getCount());
    }

    function setModeButtons(mode) {
      modeBtns.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.shir7PersMode === mode);
      });
    }

    function writeProps(count) {
      if (!propsWrap) return;
      propsWrap.innerHTML = '';
      propsWrap.hidden = count <= 0;

      // Uma property por zona — objetiva e sem duplicar (Yampi mostra tudo).
      const entries = [];
      if (count > 0) {
        zones.forEach((zone) => {
          const s = selection[zone.id];
          if (!s || !s.artId) return;
          entries.push([zone.label, formatSelectionDetail(s)]);
        });
      }

      entries.forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        const formId = propsWrap.dataset.formId;
        if (formId) input.setAttribute('form', formId);
        propsWrap.appendChild(input);
      });
    }

    function renderSummary() {
      const count = getCount();
      if (countLabelEl) countLabelEl.textContent = countSelectedLabel(count);
      if (summaryList) {
        summaryList.innerHTML = '';
        zones.forEach((zone) => {
          const s = selection[zone.id];
          if (!s || !s.artId) return;
          const li = document.createElement('li');
          li.textContent = `${zone.label}: ${formatSelectionDetail(s)}`;
          summaryList.appendChild(li);
        });
      }
      if (summary) summary.hidden = count === 0;
      writeProps(count);
    }

    function applyComModeUI() {
      setModeButtons('com');
      renderSummary();
    }

    function applySemMode(notifyVariant) {
      setModeButtons('sem');
      if (summary) summary.hidden = true;
      Object.keys(selection).forEach((k) => delete selection[k]);
      writeProps(0);
      clearPersState(handle);
      selectPersonalizationValue(root, productMeta, 0, !!notifyVariant);
    }

    function openModal() {
      if (!modal || opening) return;
      opening = true;
      try {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
        requestAnimationFrame(() => {
          try {
            renderZones();
            updateModalCount();
            modal.hidden = false;
            document.documentElement.classList.add('shir7-pers-modal-open');
            document.body.classList.add('shir7-pers-modal-open');
          } catch (err) {
            console.error('SHIR7 openModal render', err);
            alert('Não foi possível abrir a personalização. Tente recarregar a página.');
          } finally {
            opening = false;
          }
        });
      } catch (err) {
        opening = false;
        console.error('SHIR7 openModal', err);
      }
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('shir7-pers-modal-open');
      document.body.classList.remove('shir7-pers-modal-open');
    }

    function validateSelection() {
      syncCustomFieldsFromDom();
      const count = getCount();
      // 0 artes = válido: volta para "Sem personalização"
      if (count <= 0) return { ok: true, count: 0, clear: true };
      if (count > 5) return { ok: false, message: 'Máximo de 5 personalizações.' };

      for (const zone of zones) {
        const s = selection[zone.id];
        if (!s) continue;
        if (artNeedsName(s.type) && !String(s.customName || '').trim()) {
          return { ok: false, message: `Digite o nome na parte: ${zone.label}.` };
        }
        if (artNeedsNumber(s.type) && !String(s.customNumber || '').trim()) {
          return { ok: false, message: `Digite o número na parte: ${zone.label}.` };
        }
      }

      const valueMeta = findVariantValue(productMeta.values, count);
      if (!valueMeta) {
        return {
          ok: false,
          message: `Cadastre a variante "${countLabel(count)}" no produto da Shopify.`,
        };
      }
      if (valueMeta.available === false) {
        return { ok: false, message: `A opção "${valueMeta.label}" está indisponível.` };
      }
      return { ok: true, count };
    }

    function confirmSelection() {
      const result = validateSelection();
      if (!result.ok) {
        alert(result.message);
        return;
      }

      // Nenhuma arte = remover personalização (equivale a "Sem personalização")
      if (result.count <= 0 || result.clear) {
        applySemMode(true);
        closeModal();
        setTimeout(boot, 150);
        setTimeout(boot, 450);
        return;
      }

      // Salva ANTES do Dawn re-render (que destroi este HTML)
      persist();
      const ok = selectPersonalizationValue(root, productMeta, result.count, true);
      if (!ok) {
        alert(
          'Não foi possível aplicar a personalização. Verifique se as opções 1–5 personalizações existem no produto.'
        );
        return;
      }
      applyComModeUI();
      closeModal();
      setTimeout(boot, 150);
      setTimeout(boot, 450);
    }

    modeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const mode = btn.dataset.shir7PersMode;
        if (mode === 'sem') applySemMode(true);
        else openModal();
      });
    });

    openBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openModal();
    });

    // listeners de modal: só uma vez por nó
    if (modal && modal.dataset.shir7ModalBound !== '1') {
      modal.dataset.shir7ModalBound = '1';
      // Bloqueia salvar/arrastar artes (concorrentes)
      modal.addEventListener('contextmenu', (e) => {
        if (e.target.closest('.shir7-pers-art__media, .shir7-pers-art__pick')) {
          e.preventDefault();
        }
      });
      modal.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });
      modal.querySelectorAll('[data-shir7-pers-close]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          closeModal();
        });
      });
      confirmBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        confirmSelection();
      });
    } else if (confirmBtn && !confirmBtn.dataset.shir7Bound) {
      confirmBtn.dataset.shir7Bound = '1';
      confirmBtn.addEventListener('click', (e) => {
        e.preventDefault();
        confirmSelection();
      });
    }

    // ====== Restaura estado (NÃO força "sem" ao iniciar) ======
    const storedCount = restoreFromStorage();
    const radioCount = readCurrentPersCount(root, productMeta);
    const wantCount = storedCount > 0 ? storedCount : radioCount;

    if (wantCount > 0) {
      const already = readCurrentPersCount(root, productMeta);
      // Evita storm de re-fetchs se o morph ainda não refletiu a opção
      const shouldNotify = already !== wantCount && !window.__shir7PersApplying;
      if (shouldNotify) window.__shir7PersApplying = true;
      selectPersonalizationValue(root, productMeta, wantCount, shouldNotify);
      if (shouldNotify) {
        setTimeout(() => {
          window.__shir7PersApplying = false;
        }, 600);
      }
      applyComModeUI();
    } else {
      setModeButtons('sem');
      if (summary) summary.hidden = true;
    }
  }

  function boot() {
    // Modais no body ficam de sessões anteriores; a section sempre traz um novo
    document.querySelectorAll('body > [data-shir7-pers-modal]').forEach((m) => m.remove());
    document.querySelectorAll('[data-shir7-pers]').forEach(initRoot);
  }

  boot();

  if (!window.__shir7PersListeners) {
    window.__shir7PersListeners = true;

    document.addEventListener('shopify:section:load', boot);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
          // Reaplica UI após o Dawn trocar variant-selects
          setTimeout(boot, 100);
          setTimeout(boot, 350);
        });
      } catch (e) {
        /* ignore */
      }
    }
  }
})();
